<script>
import router from "../../router";
import Alert from "@/components/Alert";
export default {
  name: "AddDinningOption",
  components: {
    Alert
  },
  data() {
    return {
      stores: [],
      selectedStores: [],
      dinning_option: {
        name: ""
      },
      isAll: false,
      availableStoreStr: ""
    };
  },
  methods: {
    checkAllStores(event) {
      this.selectedStores = [];
      this.availableStoreStr = "";

      if (this.isAll) {
        for (var i = 0; i < this.stores.length; i++) {
          this.selectedStores.push(this.stores[i].id);
        }
      }
      this.setAvailableStr();
    },

    setAvailableStr() {
      this.availableStoreStr = "";
      var nAvailableStore = 0;
      for(let i=0; i<this.selectedStores.length; i++){
        if(this.$_.findIndex(this.stores, {'id': this.selectedStores[i]}) != -1){
          nAvailableStore += 1
        }
      }
      this.isAll = false
      if(nAvailableStore == this.stores.length){
        this.isAll = true
      }
      if (this.selectedStores.length > 0) {
        if (this.isAll) {
          this.availableStoreStr = this.$lang.messages.available_in_all_stores;
        } else {
          if (nAvailableStore == 1) {
            this.availableStoreStr = `${this.$lang.messages.available_in} 1 ${this.$lang.messages.store.toLowerCase()}`;
          } else {
            this.availableStoreStr = `${this.$lang.messages.available_in} ${nAvailableStore} ${this.$lang.messages.stores.toLowerCase()}`;
          }
        }
      }
    },
    checkUncheckStore(event) {
      this.setAvailableStr();
      if (event && !event.target.checked) {
        this.isAll = false;
      }
      
    },
    getStores() {
      this.stores = [];
      this.$api
        .getAPI({
          _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}`
        })
        .then(res => {
          this.stores = res.list;
          if (!this.dinning_option.id){
            this.checkAllStores();
          }
          this.setAvailableStr()
        });
    },
    details(id) {
      this.dinning_option = {};

      this.$api
        .getAPI({
          _action: "/backoffice-setting/dinning-option/details/" + id
        })
        .then(res => {
          this.dinning_option = res;

          if (res.list && res.list.length > 0) {
            this.selectedStores = res.list;
          } else {
            this.selectedStores = [];
          }
          this.setAvailableStr();
        });
    },
    save() {
      if (this.selectedStores.length > 0) {
        this.dinning_option.list = this.selectedStores;
      } else {
        this.dinning_option.list = [];
      }
      if (this.dinning_option.id) {
        this.$api
          .putAPI({
            _action: "/backoffice-setting/dinning-option/update",
            _body: this.dinning_option,
            _buttonId: "save-btn"
          })
          .then(res => {
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });

            router.push("/settings");
          })
          .catch(e => {});
      } else {
        this.$api
          .postAPI({
            _action: "/backoffice-setting/dinning-option/add",
            _body: this.dinning_option,
            _buttonId: "save-btn"
          })
          .then(res => {
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });

            router.push("/settings");
          })
          .catch(e => {});
      }
    },
    deleteDinningOption() {
      if (this.dinning_option.id) {
        this.$api
          .deleteAPI({
            _action:
              "/backoffice-setting/dinning-option/delete/" +
              this.dinning_option.id
          })
          .then(res => {
            this.$refs.deleteDinningOptionAlert.close();
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });
            router.push("/settings");
          })
          .catch(e => {
            this.$refs.deleteDinningOptionAlert.close();
          });
      }
    },
    setObj() {
      this.$refs.deleteDinningOptionAlert.message =
          this.$lang.messages.delete_dinning_option_message;
    },
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          return;
        }
      });
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.isAll = false;
      this.dinning_option.id = this.$route.params.id;
      this.details(this.$route.params.id);
    } else {
      this.isAll = true;
    }

    this.getStores();
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-6">
            <div class="card rounded-5 p-3 border">
              <div class="card-body form-style">
                <div class="row">

                  <div class="col-lg-12 mb-4">
                    <label for>{{$lang.messages.name}}</label><span style="color:#ff0000"> *</span>
                    <input
                      name="name"
                      v-model="dinning_option.name"
                      v-validate="'required|max:300'"
                      class="form-control"
                      :class="{'input': true, 'is-danger': errors.has('name') }"
                      type="text" maxlength="300"
                      v-bind:placeholder="$lang.messages.name"
                    />
                    <i v-show="errors.has('name')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('name')"
                      class="help is-danger"
                    >{{$lang.messages.please_enter_valid_name}}</span>
                  </div>

                  <div class="col-md-9">
                    <!-- <p class="mb-0">{{$lang.messages.tax_application_depends_on_dining_option}}</p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="card rounded-5 pt-1 border">
              <div
                class="card-header bg-white border-bottom cursor-pointer py-3 px-lg-5 px-4"
                data-toggle="collapse"
                data-target=".stores-list"
                aria-expanded="false"
                aria-controls="multiCollapseExample1 multiCollapseExample2"
              >
                <h4 class="font-20 d-inline">
                  {{$lang.messages.store}}
                  <span class="font-16 text-secondary ml-3 d-inline">{{availableStoreStr}}</span>
                </h4>
                <img src="/images/down-arrow.svg" width="15" class="d-inline float-right mt-1" />
              </div>
              <div class="card-body form-style collapse stores-list px-lg-5 px-4 py-lg-5 py-4">
                <div class="custom-control custom-checkbox mb-3">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="checkbox-1"
                    v-model="isAll"
                    @change="checkAllStores($event)"
                  />
                  <label
                    class="custom-control-label text-dark ml-2"
                    for="checkbox-1"
                  >{{$lang.messages.available_in_all_stores}}</label>
                </div>
                <div>
                  <div
                    class="custom-control custom-checkbox mb-3 ml-3"
                    v-for="store in stores"
                    :key="store.id"
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      :value="store.id"
                      :id="'type_'  +store.id"
                      v-model="selectedStores"
                      @change="checkUncheckStore($event)" 
                    />

                    <label
                      class="custom-control-label text-dark ml-2"
                      :for="'type_' +store.id"
                    >{{store.name}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 text-right">
            <button
              type="button"
              v-if="dinning_option.id"
              class="btn btn-outline-primary float-left"
              data-toggle="modal"
              data-target="#delete-dinning-option-modal"
              @click="setObj()"
              style="min-width: 50px;font-size: 20px"
            >
              <i class="mdi mdi-delete"></i>
            </button>
            <button
              type="button"
              class="btn btn-primary mr-3"
              @click="validateForm()"
              id="save-btn"
            >{{$lang.messages.save_btn_text}}</button>
            <button type="button" class="btn btn-outline-primary" @click="$router.go(-1)">{{$lang.messages.cancel_btn_text}}</button>
          </div>
        </div>
      </div>
    </div>

    <Alert
      @rightButtonEvent="deleteDinningOption($event)"
      :title="$lang.messages.delete_dinning_option"
      ref="deleteDinningOptionAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-dinning-option-modal"
    />
  </div>
</template>
